export const API = "https://backend.binodtamang1.com.np/api"